import { useCompany } from "@/api";
import BookingOnBehalfOf from "@/components/bookings/BookingOnBehalfOf";
import { useCompanyAdminAccess } from "@/hooks/useCompanyAdminAccess";
import { useWelcomeBookingAccess } from "@/hooks/useWelcomeBookingAccess";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
  "/_portal/company/$companyId/bookings/new",
)({
  component: NewCompanyBooking,
});

function NewCompanyBooking() {
  const { t } = useTranslation();
  const { allowWelcomeBookingAccess } = useWelcomeBookingAccess();
  const { companyId } = Route.useParams();
  const { data: company } = useCompany(companyId);
  const { allowCompanyAdminAccess } = useCompanyAdminAccess(companyId);

  const breadcrumbs = [
    {
      label: t("SIDEBAR.COMPANY_BOOKINGS"),
      path: `/company/${companyId}/bookings`,
    },
    {
      label: t("PAGES.BUILDING_BOOKING.NEW.HEADER"),
      path: `/company/${companyId}/bookings/new`,
    },
  ];

  if (!allowCompanyAdminAccess || !allowWelcomeBookingAccess) return null;
  return (
    <BookingOnBehalfOf
      companyId={companyId}
      breadcrumbs={breadcrumbs}
      headerContent={
        <>
          <h1>{t("PAGES.BUILDING_BOOKING.NEW.HEADER")}</h1>
          <p>
            {t("PAGES.BUILDING_BOOKING.NEW.SUBHEADER", {
              buildingName: company.buildingTenantName,
            })}
          </p>
        </>
      }
      onSuccessNavigateTo={`/company/${companyId}/bookings`}
    />
  );
}
